module.exports = __webpack_public_path__ + "img/rosario_generica.ef224d66.svg";